import styled from 'styled-components';

export const Center = styled.div`
  margin: auto;
`;
